import { get as _get, set as _set, merge as _merge } from 'lodash-es';

export default {
  setPlanId(state, data) {
    state.planId = data;
  },
  setOfficerName(state, data) {
    state.searchOfficerName = data;
  },
  setOfficerTotal(state, data) {
    state.saveOfficerTotal = data;
  },
  initPlan(state, { planMeta, officerList, allotList }) {
    if (officerList || allotList) {
      state.planMeta = _merge({}, state.planMeta, planMeta);
      state.officerList = officerList;
      state.allotList = allotList;
    }else{
      state.planMeta = _merge({}, state.planMeta, planMeta);
    }
  },
};
